const EXTERNAL_LINK = 'External';
const INTERNAL_LINK = 'Internal';

export { EXTERNAL_LINK, INTERNAL_LINK };
